var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm._id)?_c('div',{ref:"msg"},[_c('Message',{attrs:{"content":_vm.content,"user":_vm.user || {},"timestamp":_vm.created,"media":_vm.message.media,"highlights":_vm.highlights,"type":_vm.message.type,"timezone":_vm.timezone,"customer":_vm.customer}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }